<div class="content-block">
    <div class="row">
    <h4>Scegli il dipendente dalla lista sottostante</h4>
    </div>
    <div class="row">
        <dx-lookup [displayExpr]="displayDipendente" valueExpr="id" [dataSource]="listDipendenti"
                [searchEnabled]="true" [(value)]="idDipendente">
              </dx-lookup>
    </div>
    <div class="row div-button">
        <dx-button stylingMode="contained" type="danger" text="Annulla" (onClick)="onAnnullaDipendente()" width="150">
        </dx-button>

        <dx-button stylingMode="contained" type="success" text="Conferma" (onClick)="onScegliDipendente()" width="150">
        </dx-button>
    </div>
</div>